import styled from 'styled-components'

export const FooterContainer = styled.div`
   display: flex;
   justify-content: center;
`